const baseRoute = '/fleet-map'

export const FleetMapAreaRoutes = {
  route: baseRoute,
  VehiclePreview: {
    route: `${baseRoute}?vehicleId=:vehicleId`,
  },
}
